import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  EarnCard,
  EarnContainer,
  EarnTopCard,
  EarnTopCardButton,
} from "./Earn.styled";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserInvites } from "../../feature/referral/ReferralActions";
import {
  claimInviteErnings,
  inviteErnings,
} from "../../feature/invite/InviteActions";
import ReactLoading from "react-loading";

const Earn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const { invites } = useSelector((state) => state.referral);
  const { earning } = useSelector((state) => state.invite);
  const { inputError } = useSelector((state) => state.inputError);
  const [claimLoading, setClaimLoading] = useState(false);

  const EARN_CHART = [
    {
      friends_to_inv: 1,
      reward: 100,
      claimed: earning && earning.claimed_l1,
      can_claim: invites.filter((invite) => invite.has_machine).length >= 1,
    },
    {
      friends_to_inv: 3,
      reward: 250,
      claimed: earning && earning.claimed_l2,
      can_claim: invites.filter((invite) => invite.has_machine).length >= 3,
    },
    {
      friends_to_inv: 8,
      reward: 600,
      claimed: earning && earning.claimed_l3,
      can_claim: invites.filter((invite) => invite.has_machine).length >= 8,
    },
    {
      friends_to_inv: 20,
      reward: 1200,
      claimed: earning && earning.claimed_l4,
      can_claim: invites.filter((invite) => invite.has_machine).length >= 20,
    },
    {
      friends_to_inv: 50,
      reward: 3000,
      claimed: earning && earning.claimed_l5,
      can_claim: invites.filter((invite) => invite.has_machine).length >= 50,
    },
    {
      friends_to_inv: 100,
      reward: 6000,
      claimed: earning && earning.claimed_l6,
      can_claim: invites.filter((invite) => invite.has_machine).length >= 100,
    },
    {
      friends_to_inv: 200,
      reward: 15000,
      claimed: earning && earning.claimed_l7,
      can_claim: invites.filter((invite) => invite.has_machine).length >= 200,
    },
  ];

  useEffect(() => {
    Object.keys(user).length &&
      dispatch(getUserInvites({ referral_code: user.referral_code }));
    Object.keys(user).length && dispatch(inviteErnings({ user: user.id }));
  }, [dispatch, user]);

  return (
    <EarnContainer>
      <EarnTopCard>
        <EarnTopCardButton onClick={() => navigate("/reward")}>
          Reward Program
        </EarnTopCardButton>
        <EarnTopCardButton onClick={() => navigate("/invite")}>
          Invite Now
        </EarnTopCardButton>
      </EarnTopCard>
      <EarnCard>
        <div style={{ marginBlockEnd: "20px" }}>Total Invites</div>
        <h2 style={{ fontWeight: "bolder" }}>{invites.length}</h2>
        <div style={{ marginBlockEnd: "20px" }}>Has Purchased Miner</div>
        <h2 style={{ fontWeight: "bolder" }}>
          {invites && invites.filter((invite) => invite.has_machine).length}
        </h2>
        <div style={{ marginBlockEnd: "20px" }}>
          Earnings from invites (TRX)
        </div>
        <h2 style={{ fontWeight: "bolder" }}>
          {earning && earning.amount_earned}
        </h2>
      </EarnCard>
      <div style={{ margin: "15px" }}>
        <span>
          Your friend needs to buy at least 1 miner to be efficiently invited.
        </span>
      </div>
      <EarnCard style={{ borderRadius: "0", padding: "0" }}>
        {EARN_CHART.map((data, index, row) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "20px",
              border: "1px solid #7B36EE",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ marginInlineEnd: "10px" }}>
                <h5 style={{ lineHeight: 0, margin: "0px" }}>
                  Invite {data.friends_to_inv} friend(s)
                </h5>
              </div>
            </div>
            <button
              onClick={() => {
                setClaimLoading(true);
                dispatch(
                  claimInviteErnings({
                    user: user.id,
                    friends_to_inv: data.friends_to_inv,
                  })
                )
                  .unwrap()
                  .then((res) => {
                    setClaimLoading(false);
                    alert(
                      `${data.reward} TRX Reward for ${data.friends_to_inv} referral claimed`
                    );
                  })
                  .catch((err) => {
                    setClaimLoading(false);
                    dispatch(inviteErnings({ user: user.id }));
                    alert(
                      `${
                        inputError !== undefined
                          ? inputError
                            ? inputError
                            : null
                          : null
                      }`
                    );
                  });
              }}
              style={{
                height: "30px",
                width: "40%",
                backgroundColor: `${data.claimed && "grey"}`,
              }}
              disabled={data.claimed || (!data.claimed && !data.can_claim)}
            >
              {data.claimed ? (
                `${data.reward} TRX Claimed`
              ) : claimLoading ? (
                <ReactLoading
                  type={"spinningBubbles"}
                  height={"20px"}
                  width={"20px"}
                />
              ) : (
                `Claim ${data.reward} TRX`
              )}
            </button>
          </div>
        ))}
      </EarnCard>
    </EarnContainer>
  );
};

export default Earn;
